import React from "react";
import styles from "./AddButton.module.css";

interface AddButtonProps {
    onClick: () => void;
    isEnabled: boolean;
    text?: string;
}

export const AddButton: React.FC<AddButtonProps> = ({
                                                        onClick,
                                                        isEnabled,
                                                        text = "Add Button"
                                                    }) => {
    return isEnabled ? (
        <div
            className={styles.addButtonText}
            onClick={onClick}
        >
            {text}
        </div>
    ) : (
        <div className={styles.addButtonTextDisabled}>
            {text}
        </div>
    );
};
